import React, { useEffect, useState } from 'react';

import { GenerateForm } from '../../components/FormGenerator.components';
import { Boxed } from '../../components/Boxed.components';
import { AsyncSelect, Label } from '../../components/Input.components';
import { LabelText, Text } from '../../components/Text.components';
import { Button } from '../../components/Button.components';
import { Loader } from '../../components/Loader.components';
import { Grid } from '../../components/Grid.components';
import { Badge } from '../../components/Badge.components';
import { FileIcon, PageTitle } from '../../components/style';

import SubmitModal from './SubmitModal/index';
import { Uploader } from '../../components/Uploader.components';
import { Icon } from '../../components/style';
import { Theme } from '../../utils/theme';

export const MakeRequest = (props) => {
  // state props
  const { isLoading, requestFormsList, isLoadingSubmit, profile } = props;

  // dispatch props
  const { fetchRequestForms, redirect, form } = props;
  const { getFieldProps, getFieldError, validateFields, getFieldValue } = form;

  const [fileList, setFileList] = useState([]);

  const [submitModal, setSubmitModal] = useState(null);

  useEffect(() => {
    let data = {
      page: 1,
      size: 10
    };
    fetchRequestForms(data);
  }, []);

  //   const [ request, setRequest ] = useState({});

  console.log({ requestFormsList, fileList });

  const handleFileUpload = (file) => {
    console.log({ file });
    setFileList((prev) => [...prev, file]);
  };

  const handleFileName = (value, index ) => {
    const newList = [...fileList];
    newList[index].name = value;
    setFileList(newList);
  }

  const removeFile = (id) => { 
    const newList = fileList.filter((item, index) => index !== id);
    setFileList(newList);
  }

  const onSubmit = (data) => {
    validateFields((error, values) => {
      if (!error) {
        const payload = {
          requestTitle: values?.type?.value,
          createdBy: profile?._id,
          requestDetails: data?.map((item) => ({
            name: item?.name,
            value: item?.value,
            label: selectedRequest?.fields?.find((elem) => elem?.field_name === item?.name)?.label,
            dataType: selectedRequest?.fields?.find((elem) => elem?.field_name === item?.name)
              ?.element
          })),
          attachementUrls: fileList?.map(item => ({ fileName: item.name, base64: item.base64, type: item.type })),
          comments: []
        };

        setSubmitModal(payload);
      }
    });
  };

  const selectedRequest = getFieldValue('type')?.extra ?? {};

  console.log({ selectedRequest })

  return (
    <>
      <Boxed pad="20px">
        <PageTitle>Make a request</PageTitle>
        <Boxed pad="10px 0" maxWidth="750px">
          <Boxed maxWidth="250px" pad="0 0 5px 0">
            <AsyncSelect
              label="Request Type"
              placeholder="Select the Request type"
              options={requestFormsList?.filter(item => item.status === 'active').map((item) => ({
                label: item.title,
                value: item._id,
                extra: item
              }))}
              error={getFieldError('type') ? 'Request Description is required' : null}
              {...getFieldProps('type', {
                initialValue: null,
                rules: [{ required: true }],
                onChange: (value => setFileList([]))
              })}
            />
          </Boxed>

          {selectedRequest?.description && (
            <LabelText label="Request Description" value={selectedRequest?.description} />
          )}
        </Boxed>
        {isLoading ? (
          <Boxed display="flex" pad="20px 0">
            <Loader margin="auto" />
          </Boxed>
        ) : (
          <>
            {selectedRequest?.fields && (
              <Boxed pad="10px 0">
                {selectedRequest?.allowAttachments && <Grid desktop="300px auto" tablet="300px auto" mobile="repeat(1, 1fr)">
                  <Boxed pad="5px 0">
                    <Label>Attachments</Label>
                    <Uploader multiple={true} maxSize={2} callBack={handleFileUpload} />
                  </Boxed>
                  <Boxed pad="5px 0">
                    {fileList?.map((item, index) => <Badge key={index} display="inline-flex" color={Theme.PrimaryGrey}>
                      <FileIcon size="18px" type="doc" /> 
                      <Text margin="0 10px"><input type="text" value={item?.name} onChange={(e) => handleFileName(e?.target?.value, index)} style={{ border: 0, outline: 'none', }}/> </Text>{' '}
                      <Icon
                        color={Theme?.PrimaryRed}
                        margin=" 0 0 0 10px"
                        className="icon-trash"
                        cursor="pointer"
                        onClick={() => removeFile(index)}
                      />
                    </Badge>)}
                  </Boxed>
                </Grid>}
                <GenerateForm
                  data={selectedRequest?.fields ?? []}
                  hide_actions={false}
                  onSubmit={onSubmit}
                  submitButton={
                    <Button disabled={isLoadingSubmit} type="submit">
                      Submit Request
                    </Button>
                  }
                />
              </Boxed>
            )}
          </>
        )}
      </Boxed>
      <SubmitModal payload={submitModal} closeModal={() => setSubmitModal(null)} />
    </>
  );
};
